<!-- DatePicker adapted from https://svelte.dev/repl/6116680a6c3e49d0908624105018efb7?version=3.12.1 -->

<script>
	import { createEventDispatcher } from "svelte";
	import Calendar from "./Calendar.svelte";
	import { getMonthName } from "./date-time.js";

	const dispatch = createEventDispatcher();

	// props
	export let isAllowed = () => true;
	export let selected = new Date();

	// state
	let date, month, year, showDatePicker;

	// so that these change with props
	$: {
		date = selected.getDate();
		month = selected.getMonth();
		year = selected.getFullYear();
	}

	// handlers
	const onFocus = () => {
		showDatePicker = true;
	};

	const next = () => {
		if (month === 11) {
			month = 0;
			year = year + 1;
			return;
		}
		month = month + 1;
	};

	const prev = () => {
		if (month === 0) {
			month = 11;
			year -= 1;
			return;
		}
		month -= 1;
	};

	const onDateChange = d => {
		showDatePicker = false;
		dispatch("datechange", d.detail);
	};
</script>

<style>
	.relative {
		position: relative;
	}

	.box {
		position: absolute;
		top: 40px;
		left: 0px;
		border: 1px solid gray;
		display: inline-block;
		background: white;
	}

	.month-name {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 6px 0;
	}

	.center {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.month-button {
		background: white;
		border: none;
		margin: 0px 10px 0px 10px;
		cursor: pointer;
	}

	.date {
		width: 140px;
		font-size: 12px;
		border: 1px solid #ddd;
	}

	#prev {
		margin-right: 5px
	}

	#next {
		margin-right: 5px
	}
</style>

<div class="relative">
	<input class="date" type="text" on:focus={onFocus} value={selected.toDateString()} />
	{#if showDatePicker}
	<div class="box">
	  <div class="month-name">
	    <div class="center">
	      <button class="month-button" on:click={prev}><i class="fa fa-angle-double-left" id="prev"></i>Prev</button>
	    </div>
	    <div class="center">{getMonthName(month)} {year}</div>
	    <div class="center">
	      <button class="month-button" on:click={next}>Next<i class="fa fa-angle-double-right" id="next"></i></button>
	    </div>
	  </div>
	  <Calendar
	    {month}
	    {year}
	    date={selected}
	    {isAllowed}
	    on:datechange={onDateChange} />
	</div>
	{/if}
</div>